import { Injectable } from '@angular/core';
import { LocalDatePipe } from '../pipes/localdate.pipe';

@Injectable()
export class LocaltimeService extends LocalDatePipe {
    convert(from:string|Date, pattern: string= "Australia/Sydney"): string {
        return super.transform(from, pattern);
    }

    toUTC(from: string|Date, pattern: string = 'UTC'): string {
        return super.transform(from, 'UTC');
    }
}